import React from 'react';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import EmailLink from '@hobs/containers/EmailLink/EmailLink';
import PrivateRoute from '@hobs/auth/components/PrivateRoute';
import NotFound from '@hobs/containers/NotFound';
import SnUpdateInfoForm from '../containers/SnUpdateInfoForm';
import PrivateLayout from '../components/PrivateLayout';
import Home from '../containers/Home';
import Login from '../containers/Login';
import Logout from '../containers/Logout';
import Reset from '../containers/Reset';
import RequestedServices from '../containers/RequestedServices';
import ServiceRequest from '../containers/ServiceRequest';
import Catalog from '../containers/Catalog';
import StatementOfRequirements from '../containers/StatementOfRequirements/StatementOfRequirements';
import ServiceRequestCustom from '../containers/ServiceRequestCustom';
import ServiceRequestEdit from '../containers/ServiceRequestEdit';
import Party from '../containers/Party';
import TermsAndConditions from '../containers/TermsAndConditions';
import TermsAndConditionsView from '../containers/TermsAndConditionsView';
import Transportation from '../containers/Transportation';
import {
  ServiceRequestEditAuditLogs,
  ServiceRequestCustomAuditLogs
} from '../containers/ServiceRequestAuditLog';
import MealPlanner from '../containers/MealPlanner';
import Tickets from '../containers/Tickets';
import ChangeHistory from '../containers/ChangeHistory';

const Routes = () => {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route exact path="/login/:redirect?/:exerciseId?" component={Login} />
        <Route exact path="/reset/:userId/:token" component={Reset} />
        <Route exact path="/logout/:redirect?" component={Logout} />
        <Route
          exact
          path="/email-link/:redirect/:exerciseId"
          component={EmailLink}
        />
        <PrivateRoute
          layout={PrivateLayout}
          redirect="/logout"
          exact
          path="/"
          component={Home}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/catalog"
          component={Catalog}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/requested-services/:serviceRequestId?/:action?"
          component={RequestedServices}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request"
          component={ServiceRequest}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/sor-requisites/:action?/:guid?"
          component={StatementOfRequirements}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/party/:action?/:guid?"
          component={Party}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/custom-service-request/:serviceRequestId?/:action?"
          component={ServiceRequestCustom}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/custom-service-request-history/:serviceRequestId/:action?"
          component={ServiceRequestCustomAuditLogs}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request/:serviceRequestId"
          component={ServiceRequestEdit}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request/:serviceRequestId/edit/:action?"
          component={ServiceRequestEdit}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request/:serviceRequestId/transportation"
          component={Transportation}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request/:serviceRequestId/change-history/:action?"
          component={ChangeHistory}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/service-request-history/:serviceRequestId/:action?"
          component={ServiceRequestEditAuditLogs}
        />
        <PrivateRoute
          layout={PrivateLayout}
          layoutProps={{
            withSubmenu: false
          }}
          exact
          path="/terms-and-conditions"
          component={TermsAndConditions}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/terms-and-conditions-view"
          component={TermsAndConditionsView}
        />
        <PrivateRoute
          layout={PrivateLayout}
          layoutProps={{
            withSubmenu: false
          }}
          exact
          path="/update-info/"
          component={SnUpdateInfoForm}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/tickets/:serviceRequestId?/:ticketNumber?/:action?"
          component={Tickets}
        />
        <PrivateRoute
          layout={PrivateLayout}
          exact
          path="/meal-planner"
          component={MealPlanner}
        />
        <Route component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
